import { useSelector } from 'react-redux';
import { RootState } from '../reducers';

type AdditionalProperties = Record<string, string | number>;

export function useMixpanel(
  topLevelProperties: AdditionalProperties = {},
): (
  eventName: string,
  additionalProperties?: Record<string, string | number>,
) => void {
  const session = useSelector<RootState>(
    state => state.session,
  ) as RootState['session'];

  const properties = {
    ...topLevelProperties,
    // @ts-expect-error session isn't typed
    userId: session.user?.id,
    // @ts-expect-error session isn't typed
    userEmail: session.user?.email,
  };

  return (eventName, additionalProperties = {}) =>
    mixpanel.track(eventName, { ...properties, ...additionalProperties });
}
